<template>
  <svg
    viewBox="-808.98 440.43 299.96 15.89"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m-509.02 455.5c-10.63-10.05-27.31-15.07-50.05-15.07-34.11 0-32.36 15.07-73.13 15.07s-40.77-15.07-73.83-15.07-33.89 15.07-62.3 15.07c-18.94 0-32.49-5.02-40.64-15.07v15.89h299.96v-.82z"
    />
  </svg>
</template>
